// PERS2-87 revision 2: analytics aggregates on the client, so it must consume
// every page returned by the existing paginated transactions endpoint.
// Match the endpoint's historical default page size. This also bounds each
// request while ensuring that reports are complete regardless of their size.
export const ANALYTICS_PAGE_SIZE = 10;

export const fetchAllAnalyticsTransactions = async (apiClient, params) => {
  const firstResponse = await apiClient.get('/transactions', {
    params: { ...params, page: 1, limit: ANALYTICS_PAGE_SIZE }
  });
  const firstData = firstResponse.data.data;

  // The summary endpoint has a different, already complete response shape.
  if (params.type === 'summary') return firstData;

  const totalPages = Number(firstResponse.data.pagination?.totalPages || 1);
  const otherPages = await Promise.all(
    Array.from({ length: Math.max(0, totalPages - 1) }, (_, index) =>
      apiClient.get('/transactions', {
        params: { ...params, page: index + 2, limit: ANALYTICS_PAGE_SIZE }
      })
    )
  );
  const transactions = [
    ...(Array.isArray(firstData) ? firstData : []),
    ...otherPages.flatMap((response) => Array.isArray(response.data.data) ? response.data.data : [])
  ];

  // Keep aggregation stable if a backend page boundary ever overlaps.
  return [...new Map(transactions.map((transaction) => [transaction.id, transaction])).values()];
};
